@let reviewForm = form();

<div [formGroup]="reviewForm">
  <app-pan-card header="Suspicious Incident Report Options" subheader="Choose a matching case or create a new one">
    <div class="overflow-y-auto max-h-[900px]">
      <div
        class="space-y-4 p-4 border rounded-lg shadow"
        [class.border-blue-600]="reviewForm.get('matchingCase').value === 'new_case'"
        [class.border-gray-200]="reviewForm.get('matchingCase').value !== 'new_case'"
        (click)="createNewCase()"
      >
        <input
          panCheckbox
          type="checkbox"
          [checked]="reviewForm.get('matchingCase').value === 'new_case'"
          class="mr-2 pointer-events-none"
          data-testid="create-new-case"
        />
        <label>Create a new case</label>
      </div>

      @if (isLoadingCaseImages()) {
        <div class="w-full flex justify-center items-center my-2">
          <app-pan-spinner class="mr-2"></app-pan-spinner>
          Loading cases...
        </div>
      }

      @for (case of caseImages(); track case.case_id) {
        <div
          class="space-y-4 p-4 border rounded-lg shadow"
          [class.border-blue-600]="reviewForm.get('matchingCase').value === case.case_id"
          [class.border-gray-200]="reviewForm.get('matchingCase').value !== case.case_id"
          (click)="reviewForm.get('matchingCase').setValue(case.case_id)"
        >
          <div>
            <input
              panCheckbox
              type="checkbox"
              [checked]="reviewForm.get('matchingCase').value === case.case_id"
              class="mr-2 pointer-events-none"
            />
            <label
              >Case <strong>{{ case.case_id }}</strong></label
            >
          </div>
          <div class="grid grid-cols-1 gap-4">
            @for (imageUrl of case.urls; track imageUrl) {
              <img [src]="imageUrl" class="object-contain z-10 h-96 w-96 rounded-md" />
            }
          </div>
        </div>
      }
    </div>
  </app-pan-card>
</div>
